import React, { Component } from "react";
import AntdAvatar, {AvatarProps} from 'antd/lib/avatar';
import 'antd/lib/avatar/style';

export default class Avatar extends Component<AvatarProps> {
    render() {
        return (
          <AntdAvatar {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/avatar/index.tsx